const subSections = [
  {title: "Isolation Extérieure et Intérieure", link: "isolation"},
  {title: "Aménagement des Combles", link: "combles"},
  {title: "Couverture", link: "couverture"},
  {title: "Electricité - Plomberie - Chauffage", link: "electricite"},
  {title: "Menuisieries Extérieures", link: "menuiserie"},
  {title: "Terrassement", link: "terrassement"},
];

export default subSections;